import {
	ContractIAImportProcess,
	ImportFeedbackRatingScaleItem
} from '../../models/Entities/Contracts/ContractIAImportProcess';
import { ErrorType } from '../../models/HttpError';

export interface ContractIAImportState {
	// Último proceso IA de un contrato (puede ser null si nunca se ejecutó)
	lastProcess: ContractIAImportProcess | null;

	// Crear proceso de importación
	isCreatingProcess: boolean;
	successCreatingProcess: boolean | undefined;
	failOnCreatingProcess: boolean;

	// Obtener último proceso
	isGettingLastProcess: boolean;
	successGettingLastProcess: boolean | undefined;
	failOnGettingLastProcess: boolean;

	// Historial de procesos del contrato
	history: ContractIAImportProcess[];
	isGettingHistory: boolean;
	successGettingHistory: boolean | undefined;
	failOnGettingHistory: boolean;

	// Escala de puntuación del feedback (catálogo publicado por la API)
	ratingScale: ImportFeedbackRatingScaleItem[];
	isGettingRatingScale: boolean;
	successGettingRatingScale: boolean | undefined;
	failOnGettingRatingScale: boolean;

	// Registrar feedback del proceso (única vez, inmutable)
	isRatingProcess: boolean;
	successRatingProcess: boolean | undefined;
	failOnRatingProcess: boolean;
	// Error propio del feedback: no comparte 'error' con el resto del slice para
	// que un rechazo del rating no encienda el cartel de error del widget.
	ratingError?: ErrorType;

	// Error general
	error?: ErrorType;
}

export const ContractIAImportUnloadState: ContractIAImportState = {
	lastProcess: null,

	// Crear
	isCreatingProcess: false,
	successCreatingProcess: undefined,
	failOnCreatingProcess: false,

	// Obtener último
	isGettingLastProcess: false,
	successGettingLastProcess: undefined,
	failOnGettingLastProcess: false,

	// Historial
	history: [],
	isGettingHistory: false,
	successGettingHistory: undefined,
	failOnGettingHistory: false,

	// Escala de puntuación
	ratingScale: [],
	isGettingRatingScale: false,
	successGettingRatingScale: undefined,
	failOnGettingRatingScale: false,

	// Feedback
	isRatingProcess: false,
	successRatingProcess: undefined,
	failOnRatingProcess: false,
	ratingError: undefined,

	error: undefined
};

